export default __webpack_public_path__ + "static/media/powered-by-WAX.e49a3059.svg";